import React from 'react';
import '../styles/TestimonialsSection.css';

const testimonials = [

  {
    name: 'Jason Murphy',
    stars: 5,
    text: 'The team\'s negotiation skills and level of service and commitment was unparalleled. Highly recommended!',
    reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSUMzaFlpbDd3RRAB!2m1!1s0x0:0xfb2dbe8e30fc8b57!3m1!1s2@1:CIHM0ogKEICAgIC3hYil7wE%7CCgwI3-WxuQYQwIn4xwI%7C?hl=en'
  },
  {
    name: 'Huss Khosravi',
    stars: 5,
    text: 'Abbass and his team are highly professional and knowledgeable. He genuinely care about his clients. He provides clear, honest advice and goes the extra mile to help people achieve their property and business goals. His expertise, integrity and dedication make him a trusted advisor in the industry. Highly recommended!',
    reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTURnNWFMLVJnEAE!2m1!1s0x0:0xfb2dbe8e30fc8b57!3m1!1s2@1:CIHM0ogKEICAgMDg5aL-Rg%7CCgwI59X6vQYQ0PT8_QE%7C?hl=en'
  },
  {
    name: 'Agust',
    stars: 5,
    text: 'I had a great experience with the Abbas Group. The team was outstanding! very professional, friendly, and welcoming from the start. They were always willing to help, offering clear advice and support whenever I needed it. I was impressed by how knowledgeable and approachable everyone was, making it easy to learn and feel comfortable. Abbas Group has a fantastic team that truly stands out for their dedication and teamwork. I highly recommend them!',
    reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnSUMzcDhYREZnEAE!2m1!1s0x0:0xfb2dbe8e30fc8b57!3m1!1s2@1:CIHM0ogKEICAgIC3p8XDFg%7CCgwIjNm_uQYQ4LONpAI%7C?hl=en'
  },
  {
    name: 'nik tribhuvan',
    stars: 5,
    text: 'Sadeq and his team are incredible. They are quite knowledgeable and diligent. Their service is incredible. All my communication were promptly responded to. All my questions and queries were satisfactorily addressed. Made the entire process smooth and assuring. Great team to have by your corner regardless what your needs are. Highly recommend Sadeq and his team.',
    reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTURnX3M3bWVnEAE!2m1!1s0x0:0xfb2dbe8e30fc8b57!3m1!1s2@1:CIHM0ogKEICAgMDg_s7meg%7CCgwI9OP0vQYQsNKBzQM%7C?hl=en'
  }
];

const TestimonialsSection = () => {
  return (
    <section className="testimonials" style={{ backgroundImage: `linear-gradient(rgba(41, 43, 44, 0.6), rgba(41, 43, 44, 0.6)), url(${require('../assets/images/testimonialsbg.jpg')})` }}>
      <div className="container">
        <div className="section-header">
          <h2>What Our Clients Say</h2>
          <p>Hear from our satisfied clients about their experience with Global Properties</p>
        </div>
        <div className="testimonials-scroll-container">
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => {
              const isLongText = testimonial.text.length > 120;
              const displayText = isLongText 
                ? `${testimonial.text.substring(0, 100).trim()}...` 
                : testimonial.text;
              
              return (
                <a 
                  href={testimonial.reviewUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="testimonial-card" 
                  key={index}
                >
                  <div className="testimonial-rating">
                    {[...Array(testimonial.stars)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>
                  <p className="testimonial-text">
                    {displayText}
                  </p>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <h4>{testimonial.name}</h4>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 